import { FC } from "react";
import { AdminBorderSystem } from "../../../../../http/border/types/borderSystems";
import SystemForm from "./SystemForm";

interface BorderSystemDetailsProps {
  borderSystem?: AdminBorderSystem;
  disabled?: boolean;
  isLoading?: boolean;
}

const BorderSystemDetails: FC<BorderSystemDetailsProps> = ({
  borderSystem,
  disabled,
  isLoading,
}: BorderSystemDetailsProps) => {
  // const languages = getUILanguages(i18n.translation);
  // const controller = useTabs(languages.length);
  // const [tabs, setTabs] = useState(languages.map((x) => ({ title: x.display, value: x.value })));

  // useEffect(() => {
  //   setTabs(languages.map((x) => ({ title: x.display, value: x.value })));
  // }, [i18n.translation]);

  return <SystemForm borderSystem={borderSystem} isLoading={isLoading} isDisabled={disabled} />;

  // return <Tabs  tabs={tabs} contents={[panel]} />;
};

export default BorderSystemDetails;
